module.exports = __webpack_public_path__ + "static/media/img_12.dc26701d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_12.jpg
// module id = 530
// module chunks = 0